import { render, staticRenderFns } from "./TaskTemplateView.vue?vue&type=template&id=3d28a38a"
import script from "./TaskTemplateView.vue?vue&type=script&lang=js"
export * from "./TaskTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports